import { formatDate } from '@angular/common';
import { RoutineChecklistRequirementLinkedDocument } from '../../compliance-overview/models/inspection-checklist.model';

export function buildLinkedDocumentLabel(document: RoutineChecklistRequirementLinkedDocument | null | undefined): string {
  return document ? `${document.name}${document.extension ?? ''}` : '';
}

export function buildLinkedDocumentExpiryParts(
  validUntil: string | Date | null | undefined
): { key: string; date: string } | null {
  if (!validUntil) {
    return null;
  }

  const expiry = new Date(validUntil);
  const key = expiry < new Date()
    ? 'compliance.shared.linkedDocument.expired'
    : 'compliance.shared.linkedDocument.expiring';

  return { key, date: formatDate(expiry, 'd MMM yyyy', 'en-US') };
}